import type { NsDict } from '../ru';

export const table: NsDict<'table'> = {
  'head.leaveHint': 'Sie bleiben bis zum Ende des Spiels Teilnehmer',
  'head.lobby': '← Spiele',
  'head.title': 'Tisch {ante|cr}',
  'head.replay': 'Historische Wiedergabe',
  'head.live': 'Live',
  'head.synthetic': 'Synthetische Daten',
  'pot.pot': 'Pot',
  'pot.ante': 'Ante N',

  'feed.title': 'Züge der Teilnehmer',
  'feed.hint': 'Prognosen bis zur Abrechnung verborgen',
  'feed.empty': 'Noch keine Züge',
  'feed.ante': 'Ante',
  'feed.round': 'Runde {n}',
  'reveal.title': 'Offenlegung',
  'reveal.commitment': 'Commitment {hash}…',
  'reveal.compositionHidden': 'Zusammensetzung bis Runde 3 verborgen',

  'ready.spectator': 'Sie schauen an diesem Tisch zu.',
  'ready.confirmed': 'Teilnahme bestätigt.',
  'ready.anteAtStart': 'Die Ante von {amount|cr} wird beim Start eingezahlt.',
  'ready.cancel': 'Teilnahme zurückziehen',
  'ready.join': 'Am Spiel teilnehmen · Ante {amount|cr}',
  'ready.joinNext': 'Am nächsten Spiel teilnehmen · Ante {amount|cr}',
  'ready.notEnough': 'Nicht genug Credits für die Ante.',

  'seats.participants': 'Teilnehmer',
  'seats.atTable': 'Am Tisch',
  'seats.count': '{n}/{max} · Beträge in Cr',
  'seats.statsTitle': 'Spielerstatistik: Spiele {games}, Gewinnquote {winRate}, Nettoergebnis {net} Cr',
  'seats.colPlayer': 'Spieler',
  'seats.colRound': 'Runde',
  'seats.colRoundHint': 'Einsatz in der aktuellen Runde, Cr',
  'seats.colCommitted': 'Eingezahlt',
  'seats.colCommittedHint': 'Insgesamt in den Pot dieses Spiels eingezahlt, Cr',
  'seats.colStack': 'Rest',
  'seats.colStackHint': 'Verfügbarer Rest, Cr',
  'seats.colStatus': 'Status',
  'seats.colBalance': 'Guthaben',
  'seats.turn': 'Zug · {s} s',
  'seats.me': 'Sie',
  'seats.offline': 'offline',
  'seats.inGame': 'im Spiel',
  'seats.ready': 'bereit',
  'seats.waiting': 'wartet',
  'seats.free': 'frei',

  'stage.chart': '1 · Chart',
  'stage.chartHint': 'Richtung',
  'stage.scale': '2 · Skala',
  'stage.scaleHint': 'Preise und Punkte',
  'stage.composition': '3 · Zusammensetzung',
  'stage.compositionHint': 'Anzahl Punkte',
  'stage.candle': 'Kerze',
  'stage.candleHint': 'Warten auf Schluss',
  'stage.settle': 'Abrechnung',
  'stage.settleHint': 'Ergebnis',
  'stage.nextIn': 'Anmeldung zum nächsten Spiel in',

  'controls.spectator': 'Sie schauen diesem Spiel zu. Teilnehmen können Sie ab dem nächsten Spiel.',
  'controls.aria': 'Ihre Prognose und Aktionen',
  'controls.forecast': 'Prognose',
  'controls.forecastLocked': 'festgelegt',
  'controls.youFolded': 'Sie haben gefoldet',
  'controls.lockIn': 'Festlegung in {time}',
  'controls.direction': 'Richtung',
  'controls.up': 'Höher',
  'controls.down': 'Tiefer',
  'controls.points': 'Punkte',
  'controls.pointsRequired': 'Pflicht vor der Festlegung',
  'controls.pointsOptional': 'vorläufig, auch später möglich',
  'controls.pointsLess': 'um {tick} verringern',
  'controls.pointsMore': 'um {tick} erhöhen',
  'controls.pointsInvalid': 'Die Punktzahl muss positiv und ein Vielfaches von {tick} sein',
  'controls.pointsEnter': 'Geben Sie die Punktzahl ein',
  'controls.noticeChooseDirection': 'Wählen Sie eine Richtung — ohne sie können Sie keine Credits einzahlen. In Runde 3 ist die Richtung nicht mehr wählbar.',
  'controls.noticeNoDirectionRound3': 'Keine Richtung gewählt, und in Runde 3 ist sie nicht mehr wählbar: Bei der Festlegung scheiden Sie aus.',
  'controls.noticeRound2': 'In Runde 3 kann die Richtung nicht mehr geändert werden — nur die Punktzahl.',
  'controls.noticeRound3': 'Richtung festgelegt: In Runde 3 ändert sich nur die Punktzahl.',
  'controls.noticeNoPoints': 'Geben Sie die Punktzahl an: Ohne sie scheiden Sie bei der Festlegung in {s} s aus.',

  'controls.bet': 'Einsatz',
  'controls.bettingClosed': 'Runde {n} · Einsätze abgeschlossen',
  'controls.yourTurn': 'Ihr Zug · {s} s',
  'controls.theirTurn': '{name} ist am Zug · {s} s',
  'controls.roundBet': 'Einsatz der Runde',
  'controls.toCall': 'Zum Callen',
  'controls.raises': 'Erhöhungen',
  'controls.raisesOf': '{n} von {max}',
  'controls.statusFolded': 'Sie haben gefoldet — Ihre Teilnahme an diesem Spiel ist beendet.',
  'controls.statusAllIn': 'Sie sind All-in: keine weiteren Einsätze, die Prognose können Sie bis zur Festlegung ändern.',
  'controls.statusPrep': 'Die erste Einsatzrunde beginnt in {time}.',
  'controls.statusNextRound': 'Alle Teilnehmer haben gezogen. Die nächste Einsatzrunde öffnet in {time} {reveal}.',
  'controls.nextRevealScale': 'zusammen mit der Preisskala',
  'controls.nextRevealComposition': 'zusammen mit der Aktienzusammensetzung',
  'controls.statusLockIn': 'Alle Teilnehmer haben gezogen. Die Prognosen werden in {time} festgelegt.',
  'controls.statusWait': 'Warten Sie auf Ihren Zug. Sie können vorab eine Vorab-Aktion wählen.',
  'controls.statusRaiseLimit': 'Das Raise-Limit dieser Runde ist ausgeschöpft — Call oder Fold möglich.',
  'controls.presetMin': 'Min',
  'controls.presetHalfPot': '½ Pot',
  'controls.presetPot': 'Pot',
  'controls.presetMax': 'Max',
  'controls.betAmount': 'Einsatzhöhe',
  'controls.raiseTo': 'Raise auf',
  'controls.range': 'von {min|cr} bis {max|cr}',
  'controls.fold': 'Fold',
  'controls.check': 'Check',
  'controls.call': 'Call',
  'controls.raise': 'Raise',
  'controls.betAction': 'Bet',
  'controls.allIn': 'All-in',
  'controls.noDirection': 'Um Credits einzuzahlen, wählen Sie eine Prognoserichtung.',
  'controls.foldTitle': 'Fold',
  'controls.foldConfirm': 'Folden',
  'controls.foldBody': 'Sie verlassen das Spiel. Die eingezahlten {amount|cr} bleiben im Pot und werden nur bei einem Abbruch des Spiels erstattet.',
  'controls.dontAsk': 'Nicht mehr fragen',

  'pre.title': 'Vorab-Aktion',
  'pre.planned': 'geplant',
  'pre.none': 'Keine',
  'pre.noneHint': 'Ohne Vorab-Aktion: Bei Ihrem Zug entscheiden Sie selbst.',
  'pre.checkOnly': 'Check',
  'pre.checkOnlyHint': 'Check, wenn kein Einsatz vorliegt. Hat jemand gesetzt, bleibt die Entscheidung bei Ihnen.',
  'pre.checkFold': 'Check / Fold',
  'pre.checkFoldHint': 'Check, wenn kein Einsatz vorliegt; hat jemand gesetzt — Fold.',
  'pre.callUpTo': 'Call bis Limit',
  'pre.callUpToHint': 'Call, wenn der Betrag zum Callen das Limit nicht übersteigt; ohne Einsatz — Check. Einsatz über dem Limit — Sie entscheiden selbst.',
  'pre.limit': 'Call-Limit',
  'pre.limitHint': 'darüber — Sie entscheiden selbst',
  'pre.onceNext': 'Wird einmal ausgeführt — bei Ihrem nächsten Zug.',
  'pre.onceNearest': 'Wird einmal ausgeführt — bei Ihrem bevorstehenden Zug.',

  'allin.confirm': '{amount|cr} einzahlen',
  'allin.bodyBefore': 'Sie zahlen Ihren gesamten verfügbaren Rest ein',
  'allin.bodyAfter': 'und machen in diesem Spiel keine weiteren Einsätze. Die Prognose können Sie bis zur gemeinsamen Festlegung ändern.',
  'allin.up': 'höher',
  'allin.down': 'tiefer',
  'allin.noDirection': 'nicht gewählt',
  'allin.points': 'Vorläufige Punktzahl (Pflicht)',
  'allin.pointsPlaceholder': 'Vielfaches von {tick}',
  'allin.pointsInvalid': 'Eine streng positive Zahl, ein Vielfaches von {tick}.',

  'chart.myForecast': 'meine Prognose',
  'chart.scaleHidden': 'Preisskala bis Runde 2 verborgen · Einheiten normiert',
  'chart.waiting': 'Warten auf Indexdaten…',
  'chart.hide': 'Ausblenden',
  'chart.show': 'Einblenden',
  'chart.period': 'Periode',
  'chart.indicators': 'Indikatoren',
  'chart.activity': 'Aktivität',

  'settle.aria': 'Spielergebnis',
  'settle.cancelled': 'Spiel abgebrochen',
  'settle.walkover': 'Nur ein Teilnehmer übrig',
  'settle.title': 'Abrechnung',
  'settle.refundedNote': 'Antes erstattet, keine Kommission einbehalten',
  'settle.myNet': 'Ihr Nettoergebnis',
  'settle.composition': 'Zusammensetzung des Index:',
  'settle.colPlayer': 'Spieler',
  'settle.colForecast': 'Prognose',
  'settle.colError': 'Abweichung',
  'settle.colContributed': 'Eingezahlt',
  'settle.colPayout': 'Auszahlung',
  'settle.colRefund': 'Erstattung',
  'settle.colNet': 'Netto',
  'settle.folded': 'Fold',
  'settle.wrongDirection': 'falsche Richtung',
  'settle.pots': 'Pots',
  'settle.colPot': 'Pot',
  'settle.colAmount': 'Betrag',
  'settle.colCommission': 'Kommission',
  'settle.colRecipients': 'Empfänger (Gewicht)',
  'settle.mainPot': 'Haupt-Pot',
  'settle.sidePot': 'Side-Pot {n}',
  'settle.potRefunded': 'an die Einzahler erstattet',
  'settle.commissionByRound': 'Kommission nach Runden',
  'settle.colRound': 'Runde',
  'settle.colNewContributions': 'Neue Einzahlungen',
  'settle.withAntes': 'inkl. Antes',
  'settle.cap': 'Obergrenze',
  'settle.toHouse': 'Auf das Hauskonto einbehalten',
  'settle.reconciliation': 'Abgleich: abgebucht {debited|cr} = ausgezahlt {paid|cr} + erstattet {refunded|cr} + Hauskonto {bank|cr}',
  'settle.noWinners': 'Keine Gewinner.',

  'verify.title': 'Überprüfbarkeit',
  'verify.commitmentPre': 'Commitment',
  'verify.commitmentPost': 'vor den Einsätzen veröffentlicht —',
  'verify.match': 'stimmt überein ✓',
  'verify.mismatch': 'stimmt nicht überein ✗',
  'verify.checking': 'wird geprüft…',
  'verify.notRevealed': 'nicht offengelegt',
  'verify.hideSalt': 'Salt ausblenden',
  'verify.showSalt': 'Parameter und Salt',
  'verify.inBrowser': 'Im Browser prüfen',
  'verify.download': 'Prüfpaket herunterladen',
  'verify.packageError': 'Prüfpaket: {error}',
  // ── режимы игры (0.8.0) ──
  'head.instrument': '{symbol} · Preis offen',
  'controls.noticeChooseDirectionOpen': 'Wählen Sie die Richtung: Nach Runde 1 ist sie nicht mehr änderbar.',
  'controls.noticeNoDirectionLate': 'Keine Richtung gewählt, und sie ist nicht mehr wählbar: Bei der Fixierung scheiden Sie aus.',
  'controls.noticeFixedOpen': 'Richtung festgelegt: Bis zum Spielende ändert sich nur die Punktzahl.',
  'controls.statusNextRoundPlain': 'Alle haben gehandelt. Die nächste Einsatzrunde beginnt in {time}.',
  // ── режимы игры (0.8.0) ──
  'stage.open.r1': '1 · Richtung',
  'stage.open.r1Hint': 'danach fest',
  'stage.open.r2': '2 · Punkte',
  'stage.open.r2Hint': 'präzisieren',
  'stage.open.r3': '3 · Punkte',
  'stage.open.r3Hint': 'letzte Runde',
};
